/**
 * GapImage MDXEditor Plugin
 *
 * Renders an S3-backed image block.
 *
 * MARKDOWN SYNTAX (leafDirective - block-level):
 * ::GapImage{name="photo.jpg" rawFileName="photo-abc123.jpg"}
 *
 * Optionally carries a portable source so the image resolves from a fixed location regardless of the
 * consuming markdown's org/entity (e.g. a blueprint agenda reused in an advisor's meeting):
 *   sourceType="markdownFile" sourceOrgId="<org>" sourceEntityId="<markdown entityId>"
 *   sourceType="blueprintBlockContent" sourceEntityId="<blockId>"  (served org-agnostically from GAP)
 * These must be declared in `attributes` below so MDXEditor preserves them through parse/serialize.
 */
import { DirectiveDescriptor } from "@mdxeditor/editor"
import GapImageComponent from "./GapImageComponent"

export const DIRECTIVE_NAME = 'GapImage'

export const GapImageDirectiveDescriptor: DirectiveDescriptor = {
   name: DIRECTIVE_NAME,
   type: 'leafDirective',
   testNode(node) {
      return node.name === DIRECTIVE_NAME
   },
   attributes: ['name', 'rawFileName', 'width', 'height', 'sourceType', 'sourceEntityId', 'sourceOrgId'],
   hasChildren: false,
   Editor: GapImageComponent,
}
